import { Burner, ISourceItemData } from '@se/models';
import { Dict } from '@se/se.platform.base';
import { SLIDER_OPTIONS, TIMELINE_OPTIONS } from '../../se-toolbar/se-buttons-toolbar/redux/se-buttons-toolbar.state';
import { ToolbarSliderOptions, ToolbarTimelineOptions } from '../../se-toolbar/se-buttons-toolbar/types';
import { SearchTypeInfo } from '../search-param.model';

export interface SearchPageDiff {
    info1: string;
    info2?: string;
    date?: string;
}

export interface SearchPageFeatureState {
    actualSearchType: SearchTypeInfo;
    diff: SearchPageDiff[];
    items: any[];
    selectedItems: any[];
    leftSlider: ToolbarSliderOptions;
    rightSlider: ToolbarSliderOptions;
    timeline?: ToolbarTimelineOptions;
    selectedEquipment?: ISourceItemData;
    selectedBurnDevice?: Burner | null;
}

export type SearchPageState = Dict<SearchPageFeatureState>;

export const searchPageInitialState: SearchPageState = {
    ecg: {
        actualSearchType: null,
        diff: [],
        items: [],
        selectedItems: [],
        leftSlider: SLIDER_OPTIONS.LEFT_SLIDER_OPEN,
        rightSlider: SLIDER_OPTIONS.RIGHT_SLIDER_OPEN,
        timeline: TIMELINE_OPTIONS.TIMELINE_CLOSED,
    },
    visit: {
        actualSearchType: null,
        diff: [],
        items: [],
        selectedItems: [],
        leftSlider: SLIDER_OPTIONS.LEFT_SLIDER_OPEN,
        rightSlider: SLIDER_OPTIONS.RIGHT_SLIDER_CLOSED,
        timeline: TIMELINE_OPTIONS.TIMELINE_CLOSED,
    },
    complete_cd: {
        actualSearchType: null,
        diff: [],
        items: [],
        selectedItems: [],
        leftSlider: SLIDER_OPTIONS.LEFT_SLIDER_OPEN,
        rightSlider: SLIDER_OPTIONS.RIGHT_SLIDER_DISABLED,
        timeline: TIMELINE_OPTIONS.TIMELINE_DISABLED,
    },
    collaboration: {
        actualSearchType: null,
        diff: [],
        items: [],
        selectedItems: [],
        leftSlider: SLIDER_OPTIONS.LEFT_SLIDER_OPEN,
        rightSlider: SLIDER_OPTIONS.RIGHT_SLIDER_DISABLED,
        timeline: TIMELINE_OPTIONS.TIMELINE_DISABLED,
    },
    nre: {
        actualSearchType: null,
        diff: [],
        items: [],
        selectedItems: [],
        leftSlider: SLIDER_OPTIONS.LEFT_SLIDER_OPEN,
        rightSlider: SLIDER_OPTIONS.RIGHT_SLIDER_DISABLED,
        timeline: TIMELINE_OPTIONS.TIMELINE_DISABLED,
    },

    on_printing_cd: {
        actualSearchType: null,
        diff: [],
        items: [],
        selectedItems: [],
        leftSlider: SLIDER_OPTIONS.LEFT_SLIDER_OPEN,
        rightSlider: SLIDER_OPTIONS.RIGHT_SLIDER_DISABLED,
        timeline: TIMELINE_OPTIONS.TIMELINE_DISABLED,
    },
    telemonitoring: {
        actualSearchType: null,
        diff: [],
        items: [],
        selectedItems: [],
        leftSlider: SLIDER_OPTIONS.LEFT_SLIDER_OPEN,
        rightSlider: SLIDER_OPTIONS.RIGHT_SLIDER_OPEN,
        timeline: TIMELINE_OPTIONS.TIMELINE_DISABLED,
    },
    dummy_vnext2: {
        actualSearchType: null,
        diff: [],
        items: [],
        selectedItems: [],
        leftSlider: SLIDER_OPTIONS.LEFT_SLIDER_DISABLED,
        rightSlider: SLIDER_OPTIONS.RIGHT_SLIDER_OPEN,
        timeline: TIMELINE_OPTIONS.TIMELINE_DISABLED,
    },
    specialty: {
        actualSearchType: null,
        diff: [],
        items: [],
        selectedItems: [],
        leftSlider: SLIDER_OPTIONS.LEFT_SLIDER_OPEN,
        rightSlider: SLIDER_OPTIONS.RIGHT_SLIDER_CLOSED,
        timeline: TIMELINE_OPTIONS.TIMELINE_CLOSED,
        selectedBurnDevice: null,
    },
    execution: {
        actualSearchType: null,
        diff: [],
        items: [],
        selectedItems: [],
        leftSlider: SLIDER_OPTIONS.LEFT_SLIDER_DISABLED,
        rightSlider: SLIDER_OPTIONS.RIGHT_SLIDER_OPEN,
        timeline: TIMELINE_OPTIONS.TIMELINE_DISABLED,
    },
    toolupload: {
        actualSearchType: null,
        diff: [],
        items: [],
        selectedItems: [],
        leftSlider: SLIDER_OPTIONS.LEFT_SLIDER_DISABLED,
        rightSlider: SLIDER_OPTIONS.RIGHT_SLIDER_DISABLED,
        timeline: TIMELINE_OPTIONS.TIMELINE_DISABLED,
    },
};
